import format from 'date-fns/format';
import { redirectToAuth } from 'supertokens-auth-react';
import Session from 'supertokens-auth-react/recipe/session';

import {
  DropdownMenu,
  DropdownMenuAnchorItem,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
  Icon,
  SidebarMenuButton,
  Stack,
  Text,
  useSidebar,
} from '@eluve/components';
import { clearSkippedInterstitials } from '@eluve/interstitials';
import { usePostHog } from '@eluve/posthog-react';
import { useUserIdFromSession } from '@eluve/session-helpers';
import { useUserName } from '@eluve/smart-blocks';

const DROPDOWN_OFFSET_AND_PADDING = 8;

export const AdminUserDropdownMenu = () => {
  const { isMobile, open: isOpen } = useSidebar();
  const posthog = usePostHog();
  const userId = useUserIdFromSession();
  const userDisplayName = useUserName(userId, '');

  const isCollapsed = !isOpen && !isMobile;
  const date = format(Date.now(), 'yyyy-MM-dd');

  const handleLogoutClick = async () => {
    clearSkippedInterstitials();
    posthog?.reset();
    await Session.signOut();
    redirectToAuth();
  };

  return (
    <DropdownMenu modal={!isMobile}>
      <DropdownMenuTrigger asChild>
        <SidebarMenuButton
          className="relative mt-auto mr-auto group-data-[collapsible=icon]:pl-1!"
          size="lg"
        >
          <Stack
            direction="horizontal"
            align="center"
            gap={2}
            fullWidth={false}
          >
            <Icon
              name="ShieldCheck"
              size="xl"
              className="text-sidebar-primary"
            />
            <Text
              size="sm"
              weight="medium"
              className="overflow-hidden whitespace-nowrap group-data-[collapsible=icon]:hidden"
            >
              {userDisplayName || 'Admin'}
            </Text>
          </Stack>
          <Icon
            name="ChevronsUpDown"
            size="md"
            className="ml-auto group-data-[collapsible=icon]:hidden"
          />
        </SidebarMenuButton>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="start"
        alignOffset={isCollapsed ? 0 : DROPDOWN_OFFSET_AND_PADDING}
        className="min-w-[200px]"
        onCloseAutoFocus={(event) => event.preventDefault()}
        sideOffset={isCollapsed ? DROPDOWN_OFFSET_AND_PADDING : 0}
      >
        <DropdownMenuLabel>{userDisplayName || 'Admin'}</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuAnchorItem
          href={`mailto:feedback@eluve.com?subject=Eluve Feedback - ${date}`}
          text="Contact Us"
        />
        <DropdownMenuItem onClick={handleLogoutClick}>Log Out</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
